import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import "element-plus/theme-chalk/index.css";
import ElementPlus, {ElNotification} from "element-plus";

createApp(App).use(ElementPlus).mount('#app')
